<template>
  <b-alert
      :show="show"
      class="d-flex justify-content-start align-items-start text-break"
      :style="`background-color: ${selected_option.background_color}; border-color: ${selected_option.border_color}`">
    <i :class="`${selected_is_circle} icon-${selected_option.icon} text-${selected_option.icon_color} mr-2`"
       :style="`${hideCircleToIcon ? null : `background-color: ${selected_option.icon_background_color};`}`"/>
    <small class="text-dark"> {{ message }}
      <a
          v-if="containsLink"
          class="font-weight-bold"
          style="color: black; cursor: pointer;"
          @click.prevent="$router.push({ name: linkPath, params: { type: typePath } })">
        <u>Haz click acá para gestionar</u>
      </a>
    </small>
  </b-alert>
</template>

<script>
export default {
  name: "Informative",
  props: {
    message: String,
    hideCircleToIcon: Boolean,
    show: Boolean,
    type: String,
    containsLink: Boolean,
    linkPath: String,
    typePath: String
  },
  computed: {
    /**
     * valida las opciones y retorna de existir sino se agrega una por defecto
     **/
    selected_option() {
      if (this.allowed_options[this.type]) {
        return this.allowed_options[this.type];
      }
      return {
        icon: 'info',
        icon_background_color: '#004BD1',
        icon_color: '#004BD1',
        background_color: '#EEF2FA',
        border_color: '#ffffff'
      }
    },
    /**
     * valida si se oculta o no el circulo del icono
     **/
    selected_is_circle() {
      return this.hideCircleToIcon ? null : "circle";
    },
    /**
     * lista de opciones permitidas
     **/
    allowed_options() {
      return {
        warning: {
          icon: "warning",
          icon_background_color: "#E82800",
          icon_color: "danger",
          background_color: "#FFC7C7",
          border_color: "#ffffff"
        },
        notification: {
          icon: "notification ",
          icon_background_color: "#E82800",
          icon_color: "warning",
          background_color: "#FACE80",
          border_color: "#ffffff"
        }
        , warningYellow: {
          icon: "warning",
          icon_background_color: "#E56401",
          icon_color: "warning",
          background_color: "#FFFBE6",
          border_color: "#ffc107"
        }
        , green: {
          icon: 'circle-check'
          , icon_background_color: '#0C9E42'
          , icon_color: 'success'
          , background_color: '#F6FFED'
          , border_color: '#0C9E42'
        }
      };
    }
  }
};
</script>

<style scoped>
i.circle {
  display: inline-block;
  border-radius: 60px;
  box-shadow: 0 0 2px #888;
}
</style>
